<template>
  <div class="h-100">
    <div class="row">
      <div
        class="col-md-12"
        v-if="company && company.id && establishment && establishment.id"
      >
        <button
          @click.stop.prevent="exportTrainingPlan"
          class="btn btn-primary btn-icon mb-4"
          :disabled="isLoading"
        >
          <div
            class="spinner-border spinner-border-sm mr-2"
            role="status"
            v-if="isLoading"
          >
            <span class="sr-only"></span>
          </div>
          <span class="icon icon-file_white"></span>
          {{ $tc('exportTrainingPlan') }}
        </button>
        <TrainingPlanForm :title="$t('team.addNewTraineeTitle')" />
      </div>
      <div v-else class="col-md-12">
        <div class="box-block text-center">
          <div class="alert alert-primary">
            {{ $t('youHaveToSelectAnEstablishment') }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="false"
      class="h-100 row d-flex justify-content-center align-items-center"
    >
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrainingPlanRow from './TrainingPlanRow.vue'
import FilterModal from '@/js/components/Profile/my-training-plan/FilterModal.vue'
import { mapFields } from 'vuex-map-fields'
import Treeselect from '@riophae/vue-treeselect'
import TrainingPlanForm from '@/js/components/Profile/my-training-plan/TrainingPlanForm'

export default {
  name: 'MyTrainingPlan',
  components: {
    TrainingPlanForm,
    FilterModal,
    TrainingPlanRow,
    Treeselect,
  },
  data() {
    return {
      isLoading: false,
      page: 1,
      q: '',
      orderDirection: 'service',
      traineesList: [],
      isFiltred: false,
      filterData: {},
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment', 'company']),
    ...mapFields([]),
    directionClass() {
      if (this.orderDirection == 'service') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
  },
  mounted() {},
  methods: {
    exportTrainingPlan() {
      let data = {}
      if (this.isAllTrainnesSelected) {
        data.ids = ['All']
        data.establishmentId = this.establishment.id
        if (this.isFiltred) {
          data.language = this.filterData?.language ?? null
          data.service = this.filterData?.service ?? null
          data.establishment = this.filterData?.establishment ?? null
          data.function = this.filterData?.function ?? null
        }
      } else {
        data.ids = this.selectedTrainees
        data.establishmentId = this.establishment.id
      }
      this.isLoading = true
      this.$store
        .dispatch('trainees/exportTrainingPlan', data)
        .then((response) => {
          var data = new Blob([response.data], {
            type: response.headers['content-type'],
          })
          let a = document.createElement('a')
          a.href = URL.createObjectURL(data)
          a.download = 'export_training_plan.xlsx'
          a.click()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss"></style>
